import { render, staticRenderFns } from "./TemplateImagesSecretario.vue?vue&type=template&id=34201d60&scoped=true&"
import script from "./TemplateImagesSecretario.vue?vue&type=script&lang=js&"
export * from "./TemplateImagesSecretario.vue?vue&type=script&lang=js&"
import style0 from "./TemplateImagesSecretario.vue?vue&type=style&index=0&id=34201d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34201d60",
  null
  
)

export default component.exports